import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AdaptiveName = ({ name }) => {
    const [displayName, setDisplayName] = useState(name);
    useEffect(() => {
        const calculateDisplayName = () => {
            const maxLength = 15;
            if (name.length <= maxLength) {
                setDisplayName(name);
            } else {

                const spaceIndex = name.lastIndexOf(' ', maxLength);
                if (spaceIndex > 0 && spaceIndex > maxLength - 5) {

                    setDisplayName(name.substring(0, spaceIndex) + '...');
                } else {

                    setDisplayName(name.substring(0, maxLength) + '...');
                }
            }
        };

        calculateDisplayName();
    }, [name]);

    return (
        <span className="name_user" title={name} style={{
            display: 'inline-block', whiteSpace: 'nowrap', overflow: 'hidden',
            textOverflow: 'ellipsis', maxWidth: '150px', verticalAlign: 'middle'
        }} >
            {displayName}
        </span>
    );
};


const TopBarUserProfile = ({ userInfo, onLogout, OnTutorialUpdate, ShowTutorialUpdate }) => {
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('.user_profile_dd')) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const truncateEmail = (email) => {
        if (!email) return '';
        if (email.length <= 18) return email;
        const atIndex = email.indexOf('@');
        if (atIndex > 8) {
            return email.substring(0, 8) + '...' + email.substring(atIndex);
        }
        return email.substring(0, 15) + '...';
    };

    return (
        <div className="right_topbar">
            <div className="icon_info" style={{ display: 'flex', alignItems: 'center' }}>
                <ul className="user_profile_dd" style={{ margin: 0, padding: 0 }}>
                    <li className={`dropdown ${isOpen ? 'show' : ''}`} style={{
                        paddingBottom: "12px",
                        listStyle: 'none'
                    }}>
                        <a className="dropdown-toggle" onClick={toggleDropdown}
                            style={{
                                display: 'inline-flex', alignItems: 'center', cursor: 'pointer', color: 'inherit',
                                textDecoration: 'none', whiteSpace: 'nowrap', minWidth: '0'
                            }} >
                            <i className="fa fa-user black_color" style={{ marginRight: '8px', flexShrink: 0 }}></i>
                            <AdaptiveName name={userInfo?.name || 'Guest'} />
                        </a>
                        <div className={`dropdown-menu ${isOpen ? 'show' : ''}`}
                            style={{
                                position: 'absolute', right: 0, minWidth: '220px', padding: '10px',
                                backgroundColor: '#fff', boxShadow: '0 2px 10px rgba(0,0,0,0.1)', borderRadius: '4px', zIndex: 1000
                            }} >
                            {/*<a className='dropdown-item' onClick={() => { navigate('#profile'); setIsOpen(false); }} style={{*/}
                            {/*    padding: '8px 10px', color: '#333',*/}
                            {/*    textDecoration: 'none', cursor: 'pointer', transition: 'all 0.2s ease', borderRadius: '4px'*/}
                            {/*}}>*/}
                            {/*    <span> My Profile</span>*/}
                            {/*</a>*/}
                            <div style={{ padding: '5px 0', borderBottom: '1px solid #eee', marginBottom: '5px' }}>
                                <span title={userInfo?.email || 'Email address'}
                                    style={{
                                        color: '#666', fontSize: '13px', display: 'block', wordBreak: 'break-all', maxWidth: '200px',
                                        whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'
                                    }} >
                                    {truncateEmail(userInfo?.email || 'Email address')}
                                </span>
                            </div>
                            {ShowTutorialUpdate === true &&
                                <a className="dropdown-item" onClick={OnTutorialUpdate}
                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 10px', color: '#333', textDecoration: 'none', cursor: 'pointer', transition: 'all 0.2s ease', borderRadius: '4px' }}
                                >
                                    <span>View Tutorial</span>
                                </a>
                            }

                            <a className="dropdown-item" onClick={onLogout}
                                style={{
                                    display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 10px', color: '#333',
                                    textDecoration: 'none', cursor: 'pointer', transition: 'all 0.2s ease', borderRadius: '4px'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.color = '#fff'; e.currentTarget.style.backgroundColor = '#15283C';
                                    const icon = e.currentTarget.querySelector('.fa-sign-out');
                                    if (icon) {
                                        icon.style.color = '#fff';
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.color = '#333';
                                    e.currentTarget.style.backgroundColor = 'transparent';
                                    const icon = e.currentTarget.querySelector('.fa-sign-out');
                                    if (icon) {
                                        icon.style.color = '#333';
                                    }
                                }}
                            >
                                <span>Log Out</span>
                                <i className="fa fa-sign-out" style={{ transition: 'color 0.2s ease', color: '#333' }}></i>
                            </a>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    );
};


const TopBar = ({ org, userInfo, onLogout, OnTutorialUpdate, ShowTutorialUpdate }) => {
    return (
        <div className="topbar" style={{ zIndex: 1048 }}>
            <nav className="navbar navbar-expand-lg navbar-light">
                <div className="full" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ display: 'inline-block', marginLeft: '25px', marginTop: '10px', }}>
                        <h1 style={{ color: 'white', margin: 0 }}>{org?.orgType === "family" ? "Admin Panel" : (org?.name || "CareWindow Admin")}</h1>
                    </div>

                    <TopBarUserProfile userInfo={userInfo} onLogout={onLogout} OnTutorialUpdate={OnTutorialUpdate} ShowTutorialUpdate={ShowTutorialUpdate} />
                </div>
            </nav>
        </div>
    );
};

export default TopBar;